export class JobResultPartialError {
    faultCode = 0;
    sourceName: string;
    sourceCode = 0;
    faultString: string;
    infoList: string;
}
